export default {"src":"/_next/static/media/burningMoney_64.89c598ab.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};